<template>
    <div>
        <avue-crud
                :option="option"
                :data="data"
                :page="page"
                @refresh-change="refreshChange"
                @search-change="searchChange"
                @row-save="store"
                @row-update="update"
                @row-del="del"
                @size-change="sizeChange"
                @current-change="currentChange"
                :upload-before="uploadBefore"
                ref="crud"
                v-model="form"
        >
            <template slot-scope="scope" slot="menu">
                <el-button icon="el-icon-tickets" size="small" type="text" v-if="scope.row.is_link===0"
                           @click.stop="handleSurveyQuestion(scope.row)">调查项目({{ scope.row.survey_question_count }})
                </el-button>
                <el-button icon="el-icon-tickets" size="small" type="text" v-if="scope.row.is_link===0"
                           @click.stop="handleResult(scope.row)">调查结果({{ scope.row.survey_question_count }})
                </el-button>
            </template>
        </avue-crud>

        <el-dialog title="调查项目" :visible.sync="dialogSurveyQuestionVisible" width="80%" center>
            <SurveyQuestion :defaultParams="{surveyId : this.surveyId }"></SurveyQuestion>
        </el-dialog>

        <el-dialog title="调查结果" :visible.sync="dialogResultVisible" width="80%" center>
            <SurveyResult :defaultParams="{surveyId : this.surveyId }"></SurveyResult>
        </el-dialog>
    </div>
</template>
<script>
  import curd from './Base/Crud'
  import SurveyQuestion from './SurveyQuestion'
  import SurveyResult from './SurveyResult'

  export default {
    mixins: [curd],
    components: {SurveyQuestion, SurveyResult},
    data() {
      return {
        form:{
          is_link:0,
          is_open:0,
        },
        dialogSurveyQuestionVisible: false,
        dialogResultVisible: false,
        // curd组件
        option: {
          viewBtn: true, // 查看按钮显隐
          addBtn: true, // 增加按钮显隐
          addBtnText: '新增调查', // 新增按钮文案
          editBtn: true, // 修改按钮显隐
          delBtn: false, // 删除按钮显隐
          columnBtn: false, // 列显隐按钮
          headerAlign: 'center', // 表头居中
          align: 'center', // 表内容 居中
          searchMenuSpan: 5, // 搜索同行 搜索所占宽度
          index: true, // 行首 索引
          dialogClickModal: false, // 是否可以通过点击modal关闭Dialog
          column: [
            {
              label: '调查标题',
              overHidden: true,
              prop: 'title',
              span: 24,
              align: 'left',
              rules: [{
                type: 'string', required: true, message: '调查标题不能为空', trigger: 'blur'
              }]
            },
            // {
            //   label: '所属分类',
            //   prop: 'type',
            //   span: 24,
            //   type: 'select',
            //   dicData: [{'label': '服务评价', 'value': 1}, {'label': 'sci调查', 'value': 2}],
            //   rules: [{
            //     required: true, message: '类型不能为空', trigger: 'blur'
            //   }]
            // },
            {
              label: '图片',
              prop: 'filepaths',
              // dataType: 'string', // 单图不要此属性
              type: 'upload',
              listType: 'picture-img', // 单图
              // listType: 'picture-card',// 多图
              oss: 'ali', // 阿里云oss配置
              loadText: '附件上传中，请稍等',
              span: 24
            },
            {   // 列表页展示
              label: '参与人数',
              prop: 'join_num',
              display: false,
              html: true,
              formatter: function (row) {
                return '<span style="color: green">' + row.current_num + '</span>/' + row.max_num;
              }
            },
            {
              label: '限制人数',
              prop: 'max_num',
              hide: true,
              type: 'number',
              rules: [{
                required: true, message: '人数不能为空', trigger: 'blur'
              }]
            },
            {
              label: '调查日期',
              prop: 'survey_time',
              type: 'daterange',
              rules: [{
                required: true, message: '调查日期不能为空', trigger: 'blur'
              }],
              valueFormat: 'yyyy-MM-dd',
              formatter: function (raw) {
                return raw.start_time + '—' + raw.end_time
              }
            },
            {
              label: '报名状态',
              prop: 'status',
              span: 24,
              addDisplay: false,
              type: 'select',
              dicUrl: this.getDic('activity.status')
            },
            {
              label: '公开结果',
              prop: 'is_open',
              type: 'radio',
              rules: [{
                required: true, message: '请选择是否公开结果', trigger: 'blur'
              }],
              dicData: [{'label': '不公开', 'value': 0}, {'label': '公开', 'value': 1}], // 0.不公开, 1.公开，
            },
            // {
            //   label: '公开方式',
            //   prop: 'public_way',
            //   hide: true,
            //   type: 'select',
            //   display:true,
            //   dicData: [{'label': '填完公开', 'value': 0}, {'label': '调查结束公开', 'value': 1}],
            // },
            {
              label: '描述',
              prop: 'desc',
              hide: true,
              type: 'textarea',
              span: 24
            },
            {
              label: '启用外链',
              prop: 'is_link',
              dicData: [{label: '不启用', value: 0}, {label: '启用', value: 1}],
              type: 'radio',
              rules: [{
                required: true, message: '请选择是否启用外链', trigger: 'blur'
              }],
              span: 20,
            },
            {
              label: '外链地址',
              prop: 'url',
              display: true,
              hide: true,
              span: 15,
            }
          ]
        },
        surveyId: null,
      }
    },
    methods: {
      // 题目列表
      handleSurveyQuestion(row) {
        this.dialogSurveyQuestionVisible = true;
        this.surveyId = row.id;
      },

      // 答题结果
      handleResult(row) {
        this.dialogResultVisible = true;
        this.surveyId = row.id;
      }
    },
    watch: {
      // 'form.is_open': {
      //   handler(val) {
      //     var public_way = this.findObject(this.option.column, 'public_way');
      //     if (val === 0) { // 公开
      //       public_way.display = true;
      //       public_way.rules = [{
      //         required: true,
      //         message: "请选择公开方式",
      //         trigger: "blur"
      //       }]
      //     } else {
      //       public_way.display = false;
      //       public_way.rules = []
      //     }
      //   },
      //   immediate: true
      // },
      'form.is_link': {
        handler(val) {
          var url = this.findObject(this.option.column, 'url');
          if (val === 1) { // 启用
            url.display = true;
            url.rules = [{
              required: true,
              message: "请输入网址",
              trigger: "blur"
            }]
          } else {
            url.display = false;
            url.rules = []
          }
        },
        immediate: true, // immediate值为true，则首次赋值时就执行handler函数，immediate值为false，则首次赋值时就不执行handler函数
      }
    }
  }
</script>
